/**
 * Essa função roda sempre que uma conversão for enviada com sucesso,
 * mas também pode ser sobrescrita por outro script carregado na página.
 *
 * @param {object} Dados da conversão enviados para a API
 */
export default function hookConversion(conversion) {
}
